import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { verifyTokenStatus } from '@/modules/RealtimeAttendance/services'
import { useAttendanceCallStore } from '@/modules/RealtimeAttendance/store/useAttendanceCall'
import { FunctionComponent, useCallback, useLayoutEffect } from 'react'
import { validateRulesToAccessMeetStore } from './store'

export const validateRulesToAccessMeet =
  // eslint-disable-next-line react/display-name
  (Component: FunctionComponent) => () => {
    const attendanceCall = useAttendanceCallStore(store => store.attendanceCall)
    const [isAbleToAccessMeet, setIsAbleToAccessMeet] =
      validateRulesToAccessMeetStore(store => [
        store.isAbleToAccessMeet,
        store.setIsAbleToAccessMeet,
      ])
    const { clinic, user } = useAuthContext()
    const { showModal } = useModalContext()

    const handleTokenValidation = useCallback(async () => {
      setIsAbleToAccessMeet(false)
      const tokenIsValidated = await verifyTokenStatus(
        Number(attendanceCall.attendanceId),
      )

      if (tokenIsValidated) {
        setIsAbleToAccessMeet(true)
      } else {
        showModal('CALL_STARTED_WITH_TOKEN', {
          title: `Informe o token de segurança ${
            clinic?.friendlyName || user?.clinic?.name
          }`,
          persistent: true,
        })
      }
    }, [
      attendanceCall.attendanceId,
      clinic?.friendlyName,
      setIsAbleToAccessMeet,
      showModal,
      user?.clinic?.name,
    ])

    useLayoutEffect(() => {
      if (clinic?.flag?.LiberarChamadaPorTokenAutorizacaoExterno) {
        handleTokenValidation()
      }
    }, [
      clinic?.flag?.LiberarChamadaPorTokenAutorizacaoExterno,
      handleTokenValidation,
    ])

    return isAbleToAccessMeet ? <Component /> : null
  }
